import { EventAssociatedModel, EventView } from '~/types/adamTypes';
export const useAppEventView = async (
  type: EventView,
  contentId: string = null,
  eventData: any = {}
): Promise<void> => {
  const { createEvent } = useAppEvent(EventAssociatedModel.View, contentId);

  const sessionStore = useSessionStore();
  const shouldIncludeLevelOfEducation: boolean = true;

  switch (type) {
    case EventView.Discipline:
      eventData.WorkingSessionId = sessionStore.id;
      break;

    default:
      break;
  }
  await createEvent(type, eventData, shouldIncludeLevelOfEducation);
};
